import { useEffect, useState } from 'react';

import { getPost } from '@/utils/contentfulPosts';

import type { Post } from '@/@types/contentful';

const useSinglePost = (slug: string) => {
  const [post, setPost] = useState<Post>();
  const [isLoading, setLoading] = useState(true);

  const getPostBySlug = async () => {
    setLoading(true);
    const result = await getPost(slug);
    setPost(result as Post);
    setLoading(false);
  };

  useEffect(() => {
    getPostBySlug().catch((err) => console.error(err));
  }, []);

  return { post, isLoading };
};

export default useSinglePost;
